import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=141080da&scoped=true"
import script from "./quote.vue?vue&type=script&lang=ts"
export * from "./quote.vue?vue&type=script&lang=ts"
import style0 from "./quote.vue?vue&type=style&index=0&id=141080da&lang=scss&scoped=true"
import style1 from "./quote.vue?vue&type=style&index=1&id=141080da&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141080da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141080da')) {
      api.createRecord('141080da', component.options)
    } else {
      api.reload('141080da', component.options)
    }
    module.hot.accept("./quote.vue?vue&type=template&id=141080da&scoped=true", function () {
      api.rerender('141080da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leads/quote.vue"
export default component.exports